<template>
    <div class="avatar_icon">
        <p v-if="type==='system'">
            <svg xmlns="http://www.w3.org/2000/svg"
                 version="1.1"
                 x="0px" y="0px"
                 viewBox="0 0 100 125"
                 enable-background="new 0 0 100 100"
                 xml:space="preserve"><g><path d="M26.744,69.209l0.011,21.856c0,0.801,0.478,1.523,1.214,1.838c0.253,0.108,0.521,0.161,0.786,0.161   c0.505,0,1.002-0.191,1.381-0.554l24.408-23.302h30.685c1.104,0,2-0.896,2-2v-50.87c0-1.104-0.896-2-2-2H12.895   c-1.104,0-2,0.896-2,2v50.87c0,1.104,0.896,2,2,2H26.744z M14.895,18.339h68.333v46.87H53.742c-0.515,0-1.009,0.198-1.381,0.554   l-21.609,20.63l-0.009-19.185c0-1.104-0.896-1.999-2-1.999H14.895V18.339z"/><path
                    d="M25.068,36.771h10.333c1.104,0,2-0.896,2-2V24.438c0-1.104-0.896-2-2-2H25.068c-1.104,0-2,0.896-2,2v10.333   C23.068,35.876,23.963,36.771,25.068,36.771z M27.068,26.438h6.333v6.333h-6.333V26.438z"/><path
                    d="M37.401,53.701V43.368c0-1.104-0.896-2-2-2H25.068c-1.104,0-2,0.896-2,2v10.333c0,1.104,0.896,2,2,2h10.333   C36.505,55.701,37.401,54.806,37.401,53.701z M33.401,51.701h-6.333v-6.333h6.333V51.701z"/><path
                    d="M44.734,41.105h11.333c1.104,0,2-0.896,2-2s-0.896-2-2-2H44.734c-1.104,0-2,0.896-2,2S43.629,41.105,44.734,41.105z"/><path
                    d="M67.234,53.438c0.434,0,0.87-0.141,1.237-0.429c7.987-6.296,8.81-18.62,1.833-27.475c-0.686-0.866-1.94-1.015-2.81-0.333   c-0.867,0.685-1.017,1.941-0.333,2.81c5.612,7.121,5.089,16.926-1.167,21.856c-0.867,0.684-1.017,1.94-0.333,2.809   C66.058,53.178,66.643,53.438,67.234,53.438z"/></g>
                <!--
                <text x="0" y="115" fill="#EEE" font-size="5px" font-weight="bold"
                      font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif">Created by mahdalenyy</text>
                <text x="0" y="120" fill="#6791DA" font-size="5px" font-weight="bold"
                      font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif">from the Noun Project</text>
                     -->
                  </svg>
        </p>
        <p v-else-if="type==='user'">
            USER
        </p>
        <p v-if="image_url && image_url.length">
            <img :src="image_url" class="avatar_image" />
        </p>
 <!--       <p>{{name}}</p> -->
    </div>
</template>

<script>
    export default {
        name: "AvatarIcon",
        props: {
            name: String,
            image_url: String,
            type: String,/* 'user','bot', 'system' */
            size: Number
        }
    }
</script>

<style scoped>
    .avatar_icon {
        width: 40px ;
    }

    .avatar_image {
        position: relative;
        border-radius: 50%;
        width: 80%;
        height: 80%;
    }

    img {
        width: 12rem;
        height: 12rem;
    }

</style>
